export default "__VITE_ASSET__1f6e1ffb__"